// extracted by mini-css-extract-plugin
module.exports = {"skeleton":"PathsList_skeleton__pzzWq","skeletonInner":"PathsList_skeletonInner__32qSM"};